export default __webpack_public_path__ + "static/logo_5-1b90b873d0adaea17fd3d46086156f11.jpg";